import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchSiteList } from "../sites/service/service";
import {
  clearDrawingsWithSpot,
  setIsCompleteSite
} from "./site/service/service";
import { bindActionCreators } from "redux";
import { getSites } from "./reducer/sites";
import SiteDialog from "./site/SiteDialog";
import Sp from "../../common/breakpoints/Sp";
import Pc from "../../common/breakpoints/Pc";
import IndexBuilderSP from "./IndexBuilderSP";
import IndexBuilderPC from "./IndexBuilderPC";
import "../../common/css/base.css";
import "../../common/css/sites.css";
import DrawingDialog from "components/DrawingDialog";
import { FETCH_SITES_SUCCESS } from "./constant/constant";
import { SET_IS_COMPLETE_SITE_SUCCESS } from "./site/constant/constant";
import { MODE_DEVICE } from "components/sites/site/LogWalkViewer/constants";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDialogShow: false,
      siteData: [],
      isShowDialogDrawing: false,
      sitesUC: null,
      isCompleteSite: false,
      fetchDone: false,
      redirectFromUrl: null
    };
  }

  componentWillMount() {
    const { state } = this.props.history.location;
    if (this.props.redirectFromUrl.isRedirectFromUrl) {
      this.setState({ redirectFromUrl: this.props.redirectFromUrl });
      this.props.fetchSiteList(this.props.isCompleteSite);
      this.props.setIsCompleteSite(this.props.isCompleteSite);
    } else {
      this.props.fetchSiteList(
        state && state.isBack ? state.isCompleteSite : false
      );
      this.props.setIsCompleteSite(
        state && state.isBack ? state.isCompleteSite : false
      );
    }
    if (state) {
      state.reload = false;
    } 
  }

  // Fetch when switch mode
  fetchSiteList = () => {
    this.props.fetchSiteList(!this.props.isCompleteSite);
    this.props.setIsCompleteSite(!this.props.isCompleteSite);
  };

  componentWillReceiveProps(props) {
    const { state } = props.history.location;
    if (state && state.reload) {
      // If back from button 一覧に戻る, check site is complete to redirect
      let isCompleteSite = state.isBack ? state.isCompleteSite : false;
      this.props.fetchSiteList(isCompleteSite);
      if (!state.isBack) {
        this.props.setIsCompleteSite(false);
      }
      state.reload = false;

    }
    if (props.type === SET_IS_COMPLETE_SITE_SUCCESS) {
      this.setState({ fetchDone: false });
    }

    if (props.type === FETCH_SITES_SUCCESS) {
      this.setState({ fetchDone: true });
    }
  }

  showHideDialogDrawing = (sitesUC = null) => {
    this.setState({
      isShowDialogDrawing: !this.state.isShowDialogDrawing,
      sitesUC
    });
  };

  render() {
    const {
      isDialogShow,
      siteData,
      isShowDialogDrawing,
      sitesUC,
      fetchDone,
      redirectFromUrl
    } = this.state;

    const { isCompleteSite } = this.props;

    const to = id => () => {
      this.props.history.push("/sites/" + id);
      this.props.clearDrawingsWithSpot();
    };

    const onChangeData = data => {
      this.setState({
        siteData: data
      });
    };

    const showDialog = () => {
      this.setState({
        isDialogShow: true
      });
    };

    const closeDialog = () => {
      this.setState({
        isDialogShow: false
      });
    };

    return (
      <>
        {fetchDone && (
          <>
            <Sp>
              <IndexBuilderSP
                sites={this.props.sites}
                to={to}
                backType={1}
                showDialog={showDialog}
                showDialogDrawing={this.showHideDialogDrawing}
                isCompleteSite={isCompleteSite}
                fetchSiteList={this.fetchSiteList}
              />
            </Sp>

            <Pc>
              <IndexBuilderPC
                sites={this.props.sites}
                siteData={siteData}
                onChangeData={onChangeData}
                to={to}
                showDialog={showDialog}
                showDialogDrawing={this.showHideDialogDrawing}
                isCompleteSite={isCompleteSite}
                fetchSiteList={this.fetchSiteList}
                redirectFromUrl={redirectFromUrl}
              />
            </Pc>
          </>
        )}

        {isDialogShow && (
          <SiteDialog isDialogShow={true} onClose={closeDialog} />
        )}

        {isShowDialogDrawing && (
          <Pc>
            <DrawingDialog
              open={isShowDialogDrawing}
              modeDevice={MODE_DEVICE.PC}
              onClose={this.showHideDialogDrawing}
              sitesUC={sitesUC}
            />
          </Pc>
        )}
        {isShowDialogDrawing && (
          <Sp>
            <DrawingDialog
              open={isShowDialogDrawing}
              modeDevice={MODE_DEVICE.SP}
              onClose={this.showHideDialogDrawing}
              sitesUC={sitesUC}
            />
          </Sp>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  type: state.rootSitesReducer.siteInfoReducer.type,
  sites: getSites(state.rootSitesReducer.sitesReducer.site),
  isCompleteSite: state.rootSitesReducer.siteInfoReducer.isCompleteSite,
  redirectFromUrl: state.rootSitesReducer.siteInfoReducer.redirectFromUrl
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchSiteList,
      clearDrawingsWithSpot,
      setIsCompleteSite
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(Index);
